import type { ReactNode } from "react";

/**
 * Секция с настройки на страницата „Маркиране": заглавна лента с буква-аватар
 * (първата буква на kicker-а), kicker, заглавие и брояч на редовете; отдолу
 * редовете (SettingRow), разделени с линии. `@container`, за да могат редовете
 * да се подреждат по ширината на самата секция, не на прозореца.
 */
export function SettingsSection({
  kicker,
  title,
  count,
  children,
}: {
  kicker: string;
  title: string;
  count: number;
  children: ReactNode;
}) {
  return (
    <section className="@container overflow-hidden rounded-2xl border border-shade-2 bg-surface">
      <div className="flex items-center gap-3 border-b border-shade-2 px-5 py-3.5">
        <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-[10px] border border-brand-tint2 bg-brand-tint text-[14px] font-extrabold text-brand-deep-ink">
          {kicker.charAt(0).toUpperCase()}
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-bold uppercase tracking-[0.11em] text-muted">
            {kicker}
          </div>
          <div className="mt-px flex items-center gap-2 text-[15px] font-bold leading-[1.25] tracking-[-0.3px] text-ink">
            <span className="min-w-0 truncate">{title}</span>
            <span className="inline-flex h-5 min-w-5 flex-shrink-0 items-center justify-center rounded-full bg-fill px-1.5 text-[11px] font-bold text-muted">
              {count}
            </span>
          </div>
        </div>
      </div>
      <div className="divide-y divide-shade-2">{children}</div>
    </section>
  );
}
